interface Props {
  size?: number;
  color?: string;
}

const WalletIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.732 8.253h4"
      ></path>
      <path
        stroke={color}
        strokeWidth="1.5"
        d="M21.566 9.253h-2.603c-1.784 0-3.23 1.343-3.23 3s1.446 3 3.23 3h2.603c.083 0 .125 0 .16-.002.54-.033.969-.432 1.004-.933.002-.033.002-.071.002-.149v-3.833c0-.077 0-.116-.002-.149-.035-.5-.465-.9-1.004-.932-.035-.002-.077-.002-.16-.002Z"
      ></path>
      <path
        stroke={color}
        strokeWidth="1.5"
        d="M21.697 9.253c-.077-1.873-.328-3.02-1.136-3.829-1.172-1.171-3.057-1.171-6.829-1.171h-3c-3.77 0-5.656 0-6.828 1.171s-1.172 3.057-1.172 6.829c0 3.77 0 5.657 1.172 6.828s3.057 1.172 6.828 1.172h3c3.772 0 5.657 0 6.829-1.172.808-.808 1.059-1.956 1.136-3.828"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18.724 12.253h.009"
      ></path>
    </svg>
  );
};

export default WalletIcon;
